import { VideoTexture } from 'three';
import Assets from "../assets";


export default class VideoGrid {
    constructor({ videos }) {
        this.videoTextures = []

        videos.forEach(video => {
            const texture = new VideoTexture(video)
            video.addEventListener('loadeddata', () => {
                texture.needsUpdate = true; 
                video.play()
            });
            video.play()
            this.videoTextures.push(texture)
        })
    }

    initialize() {
    }

    handleRender() {
    }

    handleResize() {
    }

    dispose() {
    }
}